import { Fragment } from 'react'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'

import { PanelView } from '~/panels/components/PanelWrapper/PanelWrapper.types'
import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import HomArrowLeftIcon from '~/components/Icons/svgs/HomArrowLeftIcon'

export default function PanelMobileNavigation({
  isMenuView,
  view,
}: {
  isMenuView: boolean
  view?: PanelView
}): React.ReactElement {
  const { t } = useTranslation(['generics', 'panels'])
  const router = useRouter()

  if (!view || isMenuView) {
    return <Fragment />
  }

  return (
    <div className="md:hidden px-2 flex items-center">
      <div className="flex-1 flex">
        <button className="flex flex-col items-center" onClick={() => router.back()}>
          <SVGIcon icon={HomArrowLeftIcon} />
          <small className="leading-none">{t('generics:back')}</small>
        </button>
      </div>
      <span className="text-hotpink font-semibold">{t(`panels:tab.${view}`)}</span>
      <div className="flex-1" />
    </div>
  )
}
